<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br />
            Date: {{ date }}
        </p>
        <p>
            RE: Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p>
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            I am writing this letter due to a number of actions that you have taken that have completely disregarded my rights under the FCRA, and FDCPA in which you have a legal duty to comply to.
        </p>
        <p class="letter-content">
            You failed to validate a debt at my request, which is a FDCPA violation and you continued to report a disputed debt to the Credit Bureaus: another FCRA violation. You also failed to provide me with the dunning letter, or proof of sending the original dunning letter notifying me that you are reporting me to the credit bureaus within 30 days of sending my account to collections.
        </p>
        <p class="letter-content">
            Not only have you ignored my prior requests for validation of debt letter will again request that you follow the FDCPA and please provide the following:
        </p>
        <p>
            <strong>Validation of Debt Request</strong>
            <ul>
                <li>
                    - Proof that you can collect on a debt in my state
                    <br>
                </li>
                <li>
                    - Proof of the date the account went into delinquency
                    <br>
                </li>
                <li>
                    - Your Bond (if required) in the event I need to seek counsel
                    <br>
                </li>
                <li>
                    - Proof of your right to own/collect this alleged debt
                    <br>
                </li>
                <li>
                    - Balance claimed including all fees, interest and penalties
                    <br>
                </li>
                <li>
                    - Contract bearing my personal signature
                    <br>
                </li>
            </ul>
        </p>
        <p class="letter-content">
            As you may be aware, "Estoppel by Silence" legally means that you had a duty to speak but failed to do so therefore, that must mean you agree with me that this debt is false. I will use the Estoppel in my defense since I have a track record of you not sending documents back to me.
        </p>
        <p class="letter-content">
            I expect to receive the proof requested above within 15 days of this letter. Should you again ignore my request for validation of debt I reserve the right to sue your company for violations of my consumer rights as specified under both the FDCPA and the FCRA. I may also seek damages from you if warranted.
        </p>
        <p class="letter-content">
            The certified tracking number to this letter is:
        </p>
        <p class="letter-content">
            In addition, according to Arizona Statues 32-1024, collection agencies must be licensed in the state of Arizona. I have checked to see if you have a registered agency here in the state of Arizona and you have not, so you are practicing illegally in the state of Arizona.
            <br />
            <strong>
                I intend to follow through with the suit if I do not hear back from you within 15 days.
            </strong>
        </p>
        <p>
            Thank you and I look forward to your resolving this mistake most expeditiously.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            <strong>
                CC: Federal Trade Commission, 600 Pennsylvania Ave. NW, Washington, DC 20580
            </strong>
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>